import React from 'react'
import {createStyles} from "@material-ui/core";
import {withStyles} from "@material-ui/core/styles";
import {withDataProvider, GET_ONE, showNotification} from 'react-admin'
import Button from "@material-ui/core/Button";
import FormDialog from '../../../elements/FormDialog'
import UsersSelect from '../../../elements/UsersSelect'
import DeactivateSegmentModal from '../DeactivateSegmentModal'

const styles = () => createStyles({
  button: {
    marginRight: '15px'
  },
})

const responseSuccess = {
  onSuccess: {
    notification: { body: 'Сохранено', level: 'info' },
  },
  onFailure: {
    notification: { body: 'Error', level: 'warning' },
  },
  refresh: true
}

const ButtonsGroupExpertDeveloper = withStyles(styles)(({classes, dataProvider, segmentId, statusId, experts, users, verifyStatus}: any) => {

  const setCheckStatus = async (statusId, successText: boolean | string = false, mute = false) => {
    await dataProvider('SET_CHECK_STATUS', 'segments', {
      segmentId,
      data: {
        statusId
      }
    }, successText ? {
      onSuccess: {
        notification: { body: successText, level: 'info' },
      },
      onFailure: {
        notification: { body: 'Error', level: 'warning' },
      },
      refresh: true
    } : responseSuccess)
  }

  return (
    <>
      {(verifyStatus == 1 || verifyStatus == 3) && (
        <Button onClick={() => setCheckStatus(2, 'В работе')} color="primary" className={classes.button} variant="outlined">Взять в работу</Button>
      )}
      {verifyStatus == 2 && (
        <>
          <Button onClick={() => setCheckStatus(3, 'Работа проверена')} color="primary" className={classes.button} variant="outlined">Проверена</Button>
          <Button onClick={() => setCheckStatus(1, 'Работа остановлена')} color="primary" className={classes.button}>Остановить работу</Button>
        </>
      )}
    </>
  )
})

export default withDataProvider(ButtonsGroupExpertDeveloper)